exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3AdoX{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;height:100%}.CV9pu{width:100%;height:90px}._2QZ8G span{-webkit-box-flex:50%;-ms-flex:50% 1 0%;flex:50% 1 0%}._2QZ8G span svg{margin-right:5px}._2QZ8G{display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:6px;font-size:12px;line-height:14px;color:gray}._3F7m7{font-style:normal;font-weight:500;font-size:16px;line-height:19px;color:#000;margin-bottom:8px;height:40px}._34z4P{background-color:#ffeb3b}._23cey{margin-top:5px;margin-bottom:5px;max-height:33px}", ""]);

// exports
exports.locals = {
	"root": "_3AdoX",
	"container": "CV9pu",
	"info": "_2QZ8G",
	"title": "_3F7m7",
	"emphasizePrice": "_34z4P",
	"leasingButton": "_23cey"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/AdvertCarCard/PromoutedLeasingCard/PromoutedLeasingCard.css
// module id = 1772
// module chunks = 20 21 23 32 33 38